import { createFileRoute, Link, notFound } from "@tanstack/react-router";

import { HubPlacePage, hubPlaceQuery } from "@/components/hubs/HubPlacePage";
import { buildHreflangLinks, buildLocaleMeta } from "@/lib/i18n-paths";

export const Route = createFileRoute("/fi/ski-resorts/$slug")({
  loader: async ({ params, context }) => {
    const data = await context.queryClient.ensureQueryData(hubPlaceQuery("ski-resorts", params.slug));
    if (!data) throw notFound();
    return data;
  },
  head: ({ params, loaderData }) => {
    if (!loaderData) {
      return { meta: [{ title: "Sivua ei löytynyt — what Finland" }, { name: "robots", content: "noindex" }] };
    }
    const place = (loaderData as any).place;
    const path = `/fi/ski-resorts/${params.slug}`;
    const url = `https://whatfinland.com${path}`;
    const title = `${place.name} — kävijän opas | what Finland`;
    const desc = (place.description ?? "").slice(0, 155) || `Suunnittele vierailu kohteeseen ${place.name}.`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        ...buildLocaleMeta("fi"),
        { name: "twitter:card", content: "summary_large_image" },
        ...(place.image_url?.startsWith("https://")
          ? [
              { property: "og:image", content: place.image_url },
              { name: "twitter:image", content: place.image_url },
            ]
          : []),
      ],
      links: [{ rel: "canonical", href: url }, ...buildHreflangLinks(path)],
    };
  },
  component: FiSkiResortsPlaceRoute,
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center p-8 text-center">
      <div>
        <h1 className="font-heading text-2xl">Hiihtokeskusta ei löytynyt</h1>
        <Link to="/fi/ski-resorts" className="mt-6 inline-block text-royal underline">
          Selaa hiihtokeskuksia
        </Link>
      </div>
    </div>
  ),
});

function FiSkiResortsPlaceRoute() {
  const { slug } = Route.useParams();
  return <HubPlacePage hubSlug="ski-resorts" placeSlug={slug} locale="fi" />;
}
